'use strict';

import 'jquery';
import 'bootstrap';
//import 'angular';
//import autosize from 'autosize';
/* Slick Carousel */
import 'slick-carousel';
require('!style!css!slick-carousel/slick/slick.css');
/* Fancybox */
import '@fancyapps/fancybox';
require('!style!css!@fancyapps/fancybox/dist/jquery.fancybox.css');
/* jQuery Match Height */
import 'jquery-match-height';
/* jQuery Scrollbar */
import 'jquery.scrollbar';

var use_gmap = true;
var slick_prev_arrow = '<button type="button" class="slick-prev"><i class="icon-left" aria-label="Précédent"></i></button>';
var slick_next_arrow = '<button type="button" class="slick-next"><i class="icon-right" aria-label="Suivant"></i></button>';

// Force CSS update
// https://github.com/webpack-contrib/extract-text-webpack-plugin/issues/30#issuecomment-256958209

if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
        const reporter = window.__webpack_hot_middleware_reporter__
        const success = reporter.success
        reporter.success = function () {
            document.querySelectorAll('[href*="main.css"]').forEach((link) => {
                const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`)
                link.href = nextStyleHref;
            })
            success()
        }
    }
}

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function () {
        return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
});

function is_touch_device() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}

// Gmap
function initMap() {
    // Create a map object and specify the DOM element for display.
    if (jQuery('#gmap').length) {
        var myLatLng = new google.maps.LatLng(parseFloat(jsData.gmap_center.lat), parseFloat(jsData.gmap_center.lng));
        var mapOptions = {
            center: myLatLng,
            scrollwheel: false,
            zoom: parseInt(jsData.gmap_zoom)
        };
        if (jsData.gmap_styles !== "" && jsData.gmap_styles !== null && jQuery.parseJSON(jsData.gmap_styles)) {
            mapOptions.styles = jQuery.parseJSON(jsData.gmap_styles);
        }
        var map = new google.maps.Map(document.getElementById('gmap'), mapOptions);
        // Marker options
        var marker_options = {
            position: myLatLng,
            map: map,
        };
        // Marker image
        if (jsData.gmap_marker_icon !== "" && jsData.gmap_marker_icon !== null) {
            marker_options.icon = {
                url: jsData.gmap_marker_icon.url,
                // Width conseillée : 20px.
                size: new google.maps.Size(jsData.gmap_marker_icon.width, jsData.gmap_marker_icon.height),
                // The origin for this image is (0, 0). (top left)
                origin: new google.maps.Point(0, 0),
                // Automatically center top the icon
                anchor: new google.maps.Point((jsData.gmap_marker_icon.width / 2), jsData.gmap_marker_icon.height)
            };
        }
        var marker = new google.maps.Marker(marker_options);

        // Relocate on resize
        google.maps.event.addDomListener(window, "resize", function () {
            google.maps.event.trigger(map, "resize");
            map.setCenter(myLatLng);
        });

        // Infowindow
        var infowindowContent, infowindow;
        if (jsData.address) {
            infowindowContent = '<div class="h4">' + jsData.site_name + '</div>' + jsData.address;
            infowindow = new google.maps.InfoWindow({
                content: infowindowContent
            });
            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });
        }
    }
}

(function ($) {

//    function fgToggle($this) {
//        var p = $this.closest('.form-group');
//        var i = p.find('.form-control').val();
//
//        if (p.hasClass('fg-float') && i.length) {
//            $this.closest('.fg-line').addClass('fg-toggled');
//        } else {
//            $this.closest('.fg-line').removeClass('fg-toggled');
//        }
//    }

    function smoothScroll(hash) {
        $('html, body').animate({
            scrollTop: ($(hash).offset().top - $('.fixed-top').outerHeight())
        });
    }

    function setArrowsTopPosition($slider) {
        var img_height = $('.flip-card-front > img', $slider).height();
        $('.slick-arrow', $slider).css('top', (img_height / 2) + 'px');
    }

    $(window)
            .on('resize', function () {
                $('.slick-flipping-cards').each(function () {
                    setArrowsTopPosition($(this));
                });
            })
            .on('load', function () {
                $('body').removeClass('firstload');
            })
            .on('load resize statechangecomplete', function () {
                if (is_touch_device()) {
                    $('body').addClass('touch-device');
                } else {
                    $('body').removeClass('touch-device');
                }
            })
            .on('load statechangecomplete', function () {
                // Manually Start Angular App !!
                // DO NOT add ng-app attribute in HTML !!
                angular.element(document.getElementById('content-inner')).ready(function () {
                    angular.bootstrap(document.getElementById('content-inner'), ["MyApp"]);
                });

                if (use_gmap) {
                    initMap();
                }

                if (window.location.hash) {
                    setTimeout(function () {
                        smoothScroll(window.location.hash);
                    }, 100);
                }

                if ($('#header-video').length && $('#header-video').data('hq')) {
                    var video_src = $('#header-video').data('hq');
                    if ($(window).width() <= 1024) {
                        video_src = $('#header-video').data('lq');
                    }
                    $('#header-video').append('<source src="' + video_src + '" type="video/mp4">');
                }

                $('.scrollbar-outer').scrollbar();

                $('.slick-header').slick({
                    rows: 0,
                    arrows: true,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true,
                    prevArrow: slick_prev_arrow,
                    nextArrow: slick_next_arrow,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                arrows: false,
                                dots: false,
                            }
                        },
                    ]
                });

                $('.slick-flipping-cards')
                        .on('init', function () {
                            setArrowsTopPosition($(this));
                        })
                        .slick({
                            rows: 0,
                            arrows: false,
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            prevArrow: slick_prev_arrow,
                            nextArrow: slick_next_arrow,
                            responsive: [
                                {
                                    breakpoint: 1200,
                                    settings: {
                                        arrows: true,
                                        slidesToShow: 3,
                                        slidesToScroll: 3,
                                    }
                                },
                                {
                                    breakpoint: 992,
                                    settings: {
                                        arrows: true,
                                        slidesToShow: 3,
                                        slidesToScroll: 3,
                                    }
                                },
                                {
                                    breakpoint: 770,
                                    settings: {
                                        centerMode: true,
                                        arrows: true,
                                        slidesToShow: 2,
                                        slidesToScroll: 2,
                                    }
                                },
                                {
                                    breakpoint: 500,
                                    settings: {
                                        centerMode: true,
                                        arrows: true,
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                    }
                                },
                            ]
                        })
                        .on('beforeChange', function () {
                            setArrowsTopPosition($(this));
                        });

                $('.slick-flexible-slider')
                        .on('init', function () {
                            $('.slick-flexible-slider .card-body-inner').matchHeight({
                                byRow: false,
                            });
                        })
                        .slick({
                            rows: 0,
                            arrows: true,
                            dots: false,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            centerMode: false,
                            prevArrow: slick_prev_arrow,
                            nextArrow: slick_next_arrow,
                            infinite: false,
                            responsive: [
                                {
                                    breakpoint: 992,
                                    settings: {
                                        slidesToShow: 1,
                                    }
                                },
                            ]
                        })
                        .on('afterChange', function () {
                            $.fn.matchHeight._update();
                        });

                $('.slick-picto-footer').slick({
                    arrows: false,
                    dots: false,
                    fade: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                });

                $('[data-fancybox]').fancybox({
                    hash: false
                });

                $('body').removeClass('loading firstload').addClass('animate-loader');

//                $('.fg-line .form-control').each(function () {
//                    fgToggle($(this));
//                });
            });

    $('body')
            .tooltip({
                selector: '[data-toggle="tooltip"]',
                html: true
            })
            .on('click', 'a[href^="#"]', function (event) {
                // Make sure this.hash has a value before overriding default behavior
                if (this.hash !== "") {
                    // Prevent default anchor click behavior
                    event.preventDefault();
                    smoothScroll(this.hash);
                } // End if
            })
            .on('mouseenter mouseleave', '.dropdown-hover', function (e) {
                if ($(window).width() >= 992) {
                    var _d = $(this).find('.dropdown-menu').eq(0);
                    _d[(e.type === "mouseenter") ? 'addClass' : 'removeClass']('show');
                }
            })
//            // Add animated border and remove with condition when focus and blur
//            .on('focus', '.fg-line .form-control', function () {
//                $(this).closest('.fg-line').addClass('fg-toggled');
//            })
//            .on('blur load', '.form-control', function () {
//                fgToggle($(this));
//            })
            .on('change', 'select.form-control, .custom-select', function () {
                if ($(this).val() !== "") {
                    $(this).removeClass('place_holder');
                } else {
                    $(this).addClass('place_holder');
                }
            });

})(jQuery);


// WEBPACK FOOTER //
// ./scripts/main.js